export default "__VITE_ASSET__357528e7__"